import * as React from 'react';

import {
  Button,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@rematter/ui-web';
import { Trash2 } from 'lucide-react';

import { useTranslations } from '../../../i18n/useTranslations';

type BrokeredLoadMarkAsVoidedDialogProps = {
  loadNumber: string;
  onConfirm: () => Promise<void>;
  onCancel?: () => void;
};

export const BrokeredLoadMarkAsVoidedDialog: React.FC<
  BrokeredLoadMarkAsVoidedDialogProps
> = ({ loadNumber, onConfirm, onCancel }) => {
  const t = useTranslations();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogOverlay isOpen className="@BrokeredLoadMarkAsVoidedDialog">
      <DialogContent>
        <DialogHeader>
          <div className="text-base font-semibold">
            {t.brokerage.loads.dialogs.void.title}
          </div>
        </DialogHeader>
        <div className="flex flex-col gap-2 px-4">
          <div className="text-base text-neutral/50">
            {t.brokerage.loads.dialogs.void.message(loadNumber)}
          </div>
          <div className="flex justify-end gap-2 py-4">
            <Button variant="text" color="neutral" onPress={onCancel}>
              {t.brokerage.loads.dialogs.common.cancel}
            </Button>
            <Button
              variant="solid"
              color="failure"
              onPress={handleConfirm}
              isLoading={isLoading}
              icon={<Trash2 className="size-4" />}
            >
              {t.brokerage.loads.dialogs.void.confirm}
            </Button>
          </div>
        </div>
      </DialogContent>
    </DialogOverlay>
  );
};
